import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
const CentersActions = importer('Stores/Centers/Actions')
const { getSlotsForAppointmentType } = importer('APIs/centers', null)
const { tokens } = importer('Stores/Users/Select', null)
export default function * main ({
  forDate,
  fromDateTime,
  toDateTime,
  numberOfChildren,
  centerSfid,
  appointmentType,
  rescheduleId,
  donorSfid
}) {
  try {
    const _tokens = yield select(tokens)
    const { token_type, id_token } = _tokens
    const token = `${token_type} ${id_token}`
    yield put(CentersActions.getSlotsForAppointmentTypeLoading())
    const res = yield getSlotsForAppointmentType(
      forDate,
      fromDateTime,
      toDateTime,
      numberOfChildren,
      centerSfid,
      appointmentType,
      rescheduleId,
      donorSfid,
      token
      
    )
    
    /* Note: with PD-3036/PD-6030 API will be returning status 200 when the business logic fails,
    example: Donation Center is closed on this day OR You already have an appointment scheduled for this day.*/
    // if the response have error code then call the appointment failure
    if(res.data?.code){
      yield put(CentersActions.getSlotsForAppointmentTypeFailure(res.data))
    } 
    // if the response does not have a error object then consider it as a success
    else{
      yield put(CentersActions.getSlotsForAppointmentTypeSuccess(res))
    }
  
  } catch (error) {
    yield put(CentersActions.getSlotsForAppointmentTypeFailure(error.response.data))
  }
}
